import { render } from "./PopUpNewCalculator.vue?vue&type=template&id=3cccebfa"
import script from "./PopUpNewCalculator.vue?vue&type=script&lang=js"
export * from "./PopUpNewCalculator.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__